import * as React from 'react';

// Combines multiple refs (forwarded + internally-owned) into one callback ref, so a
// component can both forward a ref to callers and keep a local ref for its own use.
export function mergeRefs<T>(
  ...refs: Array<React.Ref<T> | undefined>
): React.RefCallback<T> {
  return (value) => {
    for (const ref of refs) {
      if (!ref) continue;
      if (typeof ref === 'function') {
        ref(value);
      } else {
        (ref as React.MutableRefObject<T | null>).current = value;
      }
    }
  };
}
